/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClasseForEvaluationsDto
 */
export interface ClasseForEvaluationsDto {
    /**
     * 
     * @type {number}
     * @memberof ClasseForEvaluationsDto
     */
    idEvaluation?: number;
    /**
     * 
     * @type {string}
     * @memberof ClasseForEvaluationsDto
     */
    anneeScolaire?: string | null;
}

/**
 * Check if a given object implements the ClasseForEvaluationsDto interface.
 */
export function instanceOfClasseForEvaluationsDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ClasseForEvaluationsDtoFromJSON(json: any): ClasseForEvaluationsDto {
    return ClasseForEvaluationsDtoFromJSONTyped(json, false);
}

export function ClasseForEvaluationsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClasseForEvaluationsDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idEvaluation': !exists(json, 'idEvaluation') ? undefined : json['idEvaluation'],
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : json['anneeScolaire'],
    };
}

export function ClasseForEvaluationsDtoToJSON(value?: ClasseForEvaluationsDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idEvaluation': value.idEvaluation,
        'anneeScolaire': value.anneeScolaire,
    };
}

